var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgManual = function SvgManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#41A6DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.518 8h-.002a.82.82 0 0 0-.819.823v12.342c0 .452.37.821.825.822 1.915.005 5.125.404 7.34 2.721V11.793a.789.789 0 0 0-.114-.417C14.931 8.449 11.438 8.005 9.518 8ZM26.303 21.165V8.823a.82.82 0 0 0-.82-.823h-.001c-1.92.005-5.413.45-7.23 3.376a.789.789 0 0 0-.113.417v12.915c2.214-2.317 5.424-2.716 7.34-2.72a.826.826 0 0 0 .824-.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.177 10.846h-.597v10.319a2.106 2.106 0 0 1-2.098 2.1c-1.625.004-4.305.322-6.202 2.118 3.282-.804 6.741-.281 8.713.168A.821.821 0 0 0 29 24.749v-13.08a.824.824 0 0 0-.823-.823ZM7.42 21.165V10.846h-.597A.824.824 0 0 0 6 11.67v13.08a.82.82 0 0 0 1.007.802c1.972-.45 5.431-.972 8.713-.169-1.897-1.795-4.577-2.113-6.202-2.117a2.106 2.106 0 0 1-2.098-2.1Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }))));
};

export { SvgManual as ReactComponent };
export default __webpack_public_path__ + "86e498bbbb5c7c73c26fe6ec7fef744c.svg";